import { __ } from "@wordpress/i18n";
import Astra_Admin_Icons from "@Common/block-icons";
import { getAction, triggerAction } from '@Utils/extensions';

const ExtensionScreen = () => {

	const handlePluginActionTrigger = ( e ) => triggerAction( e );

	const getStatusClass = (value) => {
		if (value === "activated") {
			return "text-[#4AB866] pointer-events-none";
		} else {
			return "text-astra bg-white px-[0.8125rem] shadow-sm border border-solid border-[#0EA5E9] shadow-sm";
		}
	};

	const renderExtensionCards = astra_admin.woo_extensions.map((plugin, index) => {
		return (
			<div key={index} className="rounded-md px-5 py-4 bg-white border border-solid border-[#E2E8F0]">
				<div className="grid gap-3">
					<div className="flex justify-between">
						<div className="w-10 h-10 block extension-logo">
							{ plugin.logoPath.internal_icon && Astra_Admin_Icons[ plugin.logoPath.icon_path ] }
							{ ! plugin.logoPath.internal_icon && <img src={ plugin.logoPath.icon_path } width="40px" height="40px" /> }
						</div>
						<div className="star-rating flex items-center">
							{/* Render Astra_Admin_Icons['star'] five times */}
							{ Array(5).fill(0).map((_, i) => (
								<span key={i}>{ Astra_Admin_Icons['star'] }</span>
							)) }
							<span className="text-xs text-slate-400 ml-1">
								{ plugin.ratings }
							</span>
						</div>
					</div>
					<div className="text-base leading-[1.625rem] font-medium text-slate-800">
						{ plugin.title }
					</div>
					<p className="text-sm leading-[1.375rem] text-slate-400">
						{ plugin.subtitle }
					</p>
				</div>
				<div className="flex justify-between">
					<button
						data-type="button"
						data-slug={plugin.slug}
						data-redirection={plugin.redirection}
						data-action={getAction(plugin.status)}
						data-init={plugin.path}
						onClick={ handlePluginActionTrigger }
						className={` ${getStatusClass(
							plugin.status
						)} capitalize mt-3 inline-flex items-center text-sm leading-[0.875rem] font-medium rounded-md py-[0.5625rem] hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-astra-hover focus:ring-offset-2`}
					>
						{ 'installed' == plugin.status ? astra_admin.plugin_activate_text : plugin.status }
					</button>
					<div className="installation-count flex items-center mt-3">
						{Astra_Admin_Icons['chart']}
						<span className="text-xs text-slate-400 ml-1">
							{ plugin.activations }
							{ __( 'active users', 'astra' ) }
						</span>
					</div>
				</div>
			</div>
		);
	});

	return (
		<div className="px-6 w-full">
			<div className="mx-auto lg:max-w-[80rem]">
				<div className=" mt-10 mb-2 font-semibold text-2xl">
					WooCommerce { __( 'Extensions', 'astra' ) }
				</div>
				<div className="text-sm mb-8 text-[#475569]">
					{ __( 'WooCommerce extensions that will elevate your online store from good to exceptional.', 'astra' ) }
				</div>
				<main className="my-[2.43rem grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-6 ">
					{ renderExtensionCards }
				</main>
			</div>
		</div>
	);
};

export default ExtensionScreen;
